module.exports = __webpack_public_path__ + "static/img/analysis.c2eba0f5.svg";